import { cn } from '@/lib/utils';
import { squircleStyle } from '@/pages/user/tools/toolTile';
import { tileGlyphSize, tileGlyphSrc } from '@/constants/moduleColors';

// The module icon tile used on the user home page (Dashboard hero cards): a brand
// squircle filled with the module's gradient and its white glyph from /public/module-icons.
// Gradients are FULL literal Tailwind classes so the JIT keeps them (same values as the
// user Dashboard heroCards). Modules without an SVG pass a Tabler `Icon` (+ optional
// `gradient`) and get the same tile so a grid of mixed items stays uniform.
export const MODULE_TILE_GRADIENT = {
    '/module-icons/ai-tools.svg':           'bg-[linear-gradient(145deg,#1b1932,#2f2e51)]',
    '/module-icons/ai-documents.svg':       'bg-[linear-gradient(145deg,#E68A00,#FBA53A)]',
    '/module-icons/manual-photo-edit.svg':  'bg-[linear-gradient(145deg,#0067ff,#03a8ff)]',
    '/module-icons/studio-editor.svg':      'bg-[linear-gradient(145deg,#22E5C5,#14b8a6)]', // the icon's teal (its tile glyph is dark — tileGlyphSrc)
    '/module-icons/bulk-photo-editing.svg': 'bg-[linear-gradient(145deg,#10b518,#64e09a)]',
    '/module-icons/document-set.svg':       'bg-[linear-gradient(145deg,#725aff,#b08fff)]',
    '/module-icons/job.svg':                'bg-[linear-gradient(145deg,#ff9000,#febf02)]',
    '/module-icons/ai-templates.svg':       'bg-[linear-gradient(145deg,#a78bfa,#6d28d9)]',
    '/module-icons/print-media.svg':        'bg-[linear-gradient(145deg,#fb923c,#ea580c)]',
    '/module-icons/easy-tools.svg':         'bg-[linear-gradient(145deg,#ef465f,#f7949b)]',
};

const FALLBACK_GRADIENT = 'bg-[linear-gradient(145deg,#94a3b8,#475569)]';

/**
 * @param {string}   [src]      module SVG path, e.g. '/module-icons/job.svg'
 * @param {Function} [Icon]     Tabler icon component, used when there is no `src`
 * @param {string}   [gradient] literal Tailwind gradient class (overrides the module default)
 * @param {number}   [size=44]  tile size in px
 */
export default function ModuleSquircleIcon({ src, Icon, gradient, size = 44, className }) {
    return (
        <span
            aria-hidden="true"
            style={{ ...squircleStyle, width: size, height: size }}
            className={cn(
                'inline-flex flex-shrink-0 items-center justify-center',
                gradient || MODULE_TILE_GRADIENT[src] || FALLBACK_GRADIENT,
                className
            )}
        >
            {src ? (
                <img src={tileGlyphSrc(src)} alt="" draggable="false" className={cn(tileGlyphSize(src), 'object-contain')} />
            ) : Icon ? (
                <Icon size={Math.round(size * 0.5)} stroke={1.8} className="text-white" />
            ) : null}
        </span>
    );
}
